import styled, { css } from 'styled-components';

export const RequestDetailsWrapper = styled.div`
  position: absolute;
  width: calc(100% - 48px);
  height: 390px;
  background: #ffffff;
  border: 1px solid #e6e8f0;
  box-shadow: 0px 6px 10px rgba(33, 39, 73, 0.12);
  border-radius: 8px;
  top: 20px;
  left: 24px;
  right: 24px;
  z-index: 1;
`;

export const DetailsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 24px 6px 24px;

  span {
    display: inline-flex;
    cursor: pointer;
  }
`;

export const LeftHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const HeaderText = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #1b203a;
  margin: unset;
`;

export const HeaderSerial = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #8f95b2;
`;

export const Item = styled.div`
  margin: 10px 24px;

  & + & {
    margin-top: 12px;
  }
  position: relative;
`;

export const Header = styled.div`
  background: #f5f7fb;
  position: relative;
  border-radius: 8px 8px 0px 0px;
  width: 100%;
  display: grid;
  grid-template-columns: 3fr 3fr 3fr 2fr;
  grid-gap: 16px;
  padding: 8px 12px;
  cursor: pointer;

  & + & {
    margin-top: 12px;
  }
  ::after {
    content: '';
    height: 1px;
    width: 100%;
    background-color: #e6e8f0;
    position: absolute;
    left: 15px;
    right: 15px;
    bottom: 0;
    width: calc(100% - 30px);
  }
`;

export const LineContainer = styled.div`
  display: flex;
  align-items: center;
`;

interface ILineText {
  limitOfLines?: number;
}

export const LineText = styled.div<ILineText>`
  color: #474d66;
  font-size: 14px;

  ${({ limitOfLines }) =>
    !!limitOfLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${limitOfLines};
      line-clamp: ${limitOfLines};
      -webkit-box-orient: vertical;
    `};
`;

export const FirstColumn = styled.div`
  display: flex;
  align-items: center;
`;

export const RightIcon = styled.div`
  height: 20px;
  margin-right: 16px;
`;

export const ColumnsFieldsWrapper = styled.div`
  top: 0;
  position: sticky;
  z-index: 1;
`;

interface IColumnsFields {
  columns: number;
  columnFieldBorder?: string;
}

export const ColumnsFields = styled.div<IColumnsFields>`
  display: grid;
  grid-template-columns: repeat(
    ${({ columns }) => columns},
    minmax(150px, 1fr)
  );
  grid-auto-flow: column;
  grid-gap: 16px;
  padding: 12px 16px;
  background: #f5f7fb;
  width: 100%;
  border-radius: 0px 0px 8px 8px;
  overflow: hidden;
`;

export const ColumnField = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #1b203a;
  white-space: nowrap;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const Assets = styled.div`
  overflow: auto;
  max-height: 230px;
  display: grid;
`;

interface IAssetsRow {
  columns: number;
}

export const AssetRow = styled.div<IAssetsRow>`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(
    ${({ columns }) => columns},
    minmax(150px, 1fr)
  );
  grid-auto-flow: column;
  grid-gap: 16px;
  padding: 16px;
  position: relative;

  :not(:last-child)::after {
    content: '';
    height: 1px;
    width: 100%;
    background-color: #e6e8f0;
    position: absolute;
    left: 8px;
    right: 8px;
    bottom: 0;
    width: calc(100% - 16px);
  }

  width: 100%;
`;

export const AssetFieldContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const AssetField = styled.div`
  font-size: 14px;
  color: #696f8c;
  white-space: nowrap;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

interface ILineTextError {
  limitOfLines?: number;
}

export const LineTextError = styled.div<ILineTextError>`
  color: #d14343;
  font-size: 14px;

  ${({ limitOfLines }) =>
    !!limitOfLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${limitOfLines};
      line-clamp: ${limitOfLines};
      -webkit-box-orient: vertical;
    `};
`;

interface INoText {
  isError?: boolean;
}

export const NoText = styled.div<INoText>`
  color: ${({ isError }) => (isError ? '#D14343' : '#c1c4d6')};
  font-size: 14px;
  font-style: italic;
`;

export const RequestDetailsErrorContainer = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
`;
